import React from "react";
import { Oval } from "react-loader-spinner";

const Button = ({ title, loading, onClick }) => {
  return (
    <button className="button-5" role="button" onClick={onClick}>
      {loading ? (
        <Oval
          height={20}
          width={20}
          color="#fff"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          ariaLabel="oval-loading"
          secondaryColor="#fff"
          strokeWidth={4}
          strokeWidthSecondary={4}
        />
      ) : (
        title
      )}
    </button>
  );
};

export default Button;
